import { useCallback, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

import { message, Descriptions, } from "antd";
import { EditOutlined } from "@ant-design/icons";

import PageHeader from "../../components/shared/PageHeader";
import { formatDate } from "../../lib/utils";
import BlueButton from "../../components/shared/BlueButton";
import ProjectEmployees from "../../components/project/ProjectEmployees";
import ProjectEquipments from "../../components/project/ProjectEquipments";

import { getProject } from "../../api/project";
import ProjectTasks from "../../components/project/ProjectTasks";
import LoadingModal from "../../components/shared/LoadingModal";
import { UserRole } from "../../lib/constants";


export default function ProjectDetailView({ user }) {
  const { projectId } = useParams();
  const navigate = useNavigate();

  const [isLoading, setLoading] = useState(false);
  const [project, setProject] = useState(null);


  const fetchProject = useCallback(async () => {
    try {
      setLoading(true);
      const result = await getProject(projectId);
      setProject(result);
    } catch (err) {
      console.error(err);
      message.error("Something went wrong");
    }
    setLoading(false);
  }, [projectId]);

  useEffect(() => {
    fetchProject();
  }, [fetchProject, projectId]);


  const items = !project
    ? []
    : [
      {
        key: "1",
        label: "Project Name",
        children: project.name || "",
      },
      {
        key: "2",
        label: "Client",
        children: project.client ? project.client.name : "",
      },
      {
        key: "3",
        label: "Address",
        children: project.client.address.name || "",
      },
      {
        key: "4",
        label: "Site Contact Name",
        children: (project.contact?.firstName ?? "N/A") + " " + (project.contact?.lastName ?? ""),
      },
      {
        key: "5",
        label: "Site Contact Phone",
        children: project.contact?.phone || "",
        span: 2,
      },
      {
        key: "6",
        label: "Start Date",
        children: formatDate(project.startAt),
      },
      {
        key: "7",
        label: "Expected Completion",
        children: formatDate(project.endAt),
        span: 2,
      },

      {
        key: "8",
        label: "Special Instructions",
        children: project.description,
      },
    ];

  if (!project || isLoading) return <LoadingModal />;

  return (
    <main className="space-y-6 min-h-full flex flex-col">
      <PageHeader home="Projects" route="/projects" title={project.name} />

      <div className="flex-grow ml-6  flex flex-col space-y-6">
        <section className="bg-white  p-6 w-full flex space-x-28 justify-between">
          <div className="flex-grow">
            <Descriptions bordered items={items} />
          </div>
          {user?.role !== UserRole.AccountManager && (
            <BlueButton className="" icon={<EditOutlined />} type={"primary"} onClick={() => navigate(`/projects/form/${project.id}`)}>Edit Project</BlueButton>
          )}
        </section>

        <section className="w-full flex space-x-6">
          <ProjectEmployees project={project} afterClose={fetchProject} user={user} />

          <ProjectEquipments project={project} afterClose={fetchProject} user={user} />
        </section>

        <section className="w-full">
          <ProjectTasks project={project} afterClose={fetchProject} user={user} />
        </section>

      </div>
    </main >
  );
}
